// @flow

import Decimal from 'decimal.js';

import type { GridItem } from '../types';

import { getCombinedCasesAndBottlesInBottles } from './getCombinedCasesAndBottlesInBottles';
import { getBottlesFromQty } from './getBottlesFromQty';
import { getCasesFromQty } from './getCasesFromQty';
import { convertBottlesToQty } from './convertBottlesToQty';

const getLocalMaxItemQty = ({
  item,
  maxItemQty,
}: {
  item: GridItem,
  maxItemQty: any,
}) => {
  if (!maxItemQty || Object.keys(maxItemQty).length === 0 || !item) {
    return maxItemQty;
  }

  const { Uom = 1 } = item;
  const { PreviousAdd } = maxItemQty;
  const localAddedCasesToBottles = new Decimal(item.Cases * Uom);

  const totalAddedLocalBottles = Decimal.add(
    localAddedCasesToBottles,
    item.Bottles,
  );

  const totalAddedRemoteBottles = new Decimal(
    getCombinedCasesAndBottlesInBottles(PreviousAdd.Qty, item.Uom),
  );

  const totalAddedRemoteAndLocal = Decimal.sub(
    totalAddedRemoteBottles,
    totalAddedLocalBottles,
  );

  // this means that both states (local and remote) are the same
  if (totalAddedRemoteAndLocal.equals(0)) {
    return maxItemQty;
  }

  const totalAvailableRemoteBottles =
    maxItemQty.Qty !== 0
      ? new Decimal(
          getCombinedCasesAndBottlesInBottles(maxItemQty.Qty, item.Uom),
        )
      : 0;

  const totalAvailableRemoteAndLocal = Decimal.add(
    totalAvailableRemoteBottles,
    totalAddedRemoteAndLocal,
  );

  const newAddedQty = convertBottlesToQty(totalAddedLocalBottles, item.Uom);
  const newAvailableQty = convertBottlesToQty(
    totalAvailableRemoteAndLocal,
    item.Uom,
  );

  return {
    Qty: newAvailableQty,
    Cases: getCasesFromQty(newAvailableQty),
    Bottles: getBottlesFromQty(newAvailableQty, item.Uom),
    PreviousAdd: {
      Qty: newAddedQty,
      Cases: getCasesFromQty(newAddedQty),
      Bottles: getBottlesFromQty(newAddedQty, item.Uom),
    },
  };
};

export { getLocalMaxItemQty };
